var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/mudassir/.nvm/v8.7.0/lib/node_modules/react-scripts/node_modules/core-js/library/modules/_html.js
// module id = 1002
// module chunks = 0